import { Popover } from "bootstrap";

/**
 * Initialize the availability popovers
 */
export function initAvailabilityPopovers() {
    $('[data-availability-tooltip]').each(function (idx, elem) {
        let popover = Popover.getOrCreateInstance(elem);
        popover.dispose();

        var color = $(elem).data('availability-tooltip');
        var node = $('.info-availability-' + color);
        node.find('sup,.status-image').remove();
        var htmlContent = node.html();

        if(color && htmlContent) {
            Popover.getOrCreateInstance(elem, {
                html: true,
                placement: 'top',
                content: htmlContent,
                title: '',
                trigger: 'hover focus',
                delay: {"show": 200, "hide": 0}
            });
        }
    });
}

// @ts-ignore
window.initAvailabilityPopovers = initAvailabilityPopovers;
